// extracted by mini-css-extract-plugin
export default {"container":"App_container__SmaJI","image":"App_image__395a6"};